// extracted by mini-css-extract-plugin
export var container = "TextWithArrow-module--container--vUmCb";
export var ctas = "#226355";
export var grayBackground = "#f6f8fb";
export var text = "TextWithArrow-module--text--OSw3g";